<template>
  <div style="background-color:#efefef !important; z-index:2; min-height:28px;">
    <DateBar
      :display-start-date="dateBarDisplayStartDate"
      :display-end-date="dateBarDisplayEndDate"
      :start-date="delivery.startTime"
      :end-date="delivery.endTime"
      class="bar"
      full
    >
      <div class="delivery-bar" />
    </DateBar>
    <template v-if="!creatingStyles">
      <div
        v-for="(item, index) in duplicateRanges"
        :key="index"
        :style="{
          left: duplicateRangeStyles[index]
            ? duplicateRangeStyles[index].left
            : 0,
          width: duplicateRangeStyles[index]
            ? duplicateRangeStyles[index].width
            : 0,
          'z-index': index + 4,
        }"
        class="duplicate"
      />
    </template>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import DateBar from './CampaignModalPageBudgetListDateBar'
export default {
  components: { DateBar },
  props: {
    price: {
      type: String,
      default: '',
    },
    deliveries: {
      type: Array,
      default: () => {},
    },
    delivery: {
      type: Object,
      default: () => {},
    },
    bgColor: {
      type: String,
      default: '#BDBDBD',
    },
    startDate: {
      type: String,
      default: '',
    },
    endDate: {
      type: String,
      default: '',
    },
    duplicateRanges: {
      type: Array,
      default: () => [],
    },
    displayStartDate: {
      type: String,
      default: '',
    },
    displayEndDate: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      creatingStyles: true,
      duplicateRangeStyles: [],
    }
  },
  computed: {
    dateRange() {
      return dayjs(this.delivery.endTime).diff(
        this.delivery.startTime,
        'seconds',
      )
    },
    displayDateRange() {
      return dayjs(this.dateBarDisplayEndDate).diff(
        this.dateBarDisplayStartDate,
        'seconds',
      )
    },
    dateBarDisplayStartDate() {
      return dayjs(this.startDate).isAfter(this.displayStartDate)
        ? this.startDate
        : this.displayStartDate
    },
    dateBarDisplayEndDate() {
      return dayjs(this.endDate).isBefore(this.displayEndDate)
        ? this.endDate
        : this.displayEndDate
    },
  },
  watch: {
    duplicateRanges: {
      handler: function(val) {
        // duplicateRangesが更新されたとき、
        // v-forがstylesの配列を作るより先に動作することがあるのでガード
        this.creatingStyles = true
        this.initDuplicateStyle(val)
      },
      deep: true,
    },
    displayStartDate() {
      this.initDuplicateStyle(this.duplicateRanges)
    },
    displayEndDate() {
      this.initDuplicateStyle(this.duplicateRanges)
    },
  },
  mounted() {
    this.initDuplicateStyle(this.duplicateRanges)
  },
  methods: {
    initDuplicateStyle(duplicateRanges) {
      duplicateRanges.forEach((d, index) => {
        this.duplicateRangeStyles[index] = {
          width: this.createDateRangeWidthPercent(d),
          left: dayjs(this.displayStartDate).isAfter(d.start)
            ? 0
            : this.createPaddingLeftPercent(this.startPositionDate(d.start)),
          // 表示期間のStartが重複期間のStartより後ろだったらleft: 0になる
        }
      })
      this.creatingStyles = false
    },
    startPositionDate(duplicateStartDate) {
      return dayjs(duplicateStartDate).diff(this.startDate, 'seconds')
    },
    createPaddingLeftPercent(range) {
      // 最小0
      let result = range / this.displayDateRange
      result = result > 0 ? result : 0
      return result * 100 + '%'
    },
    createDateRangeWidthPercent(duplicateRange) {
      if (
        dayjs(duplicateRange.start).isAfter(this.delivery.endTime) ||
        dayjs(duplicateRange.end).isBefore(this.delivery.startTime)
      ) {
        return 0
      }
      // 最大100
      let result = duplicateRange.length / this.displayDateRange
      result = result < 1 ? result : 1
      return result * 100 + '%'
    },
  },
}
</script>

<style scoped>
.wrap {
  min-height: 28px;
  text-align: center;
  vertical-align: middle;
  position: absolute;
  top: 0;
  left: 0;
}
.bar {
  width: 100%;
  min-height: 28px;
  z-index: 3;
  position: absolute;
  left: 0;
}
.delivery-bar {
  width: 100%;
  height: 12px;
  position: absolute;
  top: calc(50% - 6px);
  z-index: 3;
  background-color: #ede2af;
}
.duplicate {
  background-color: #f76146;
  position: absolute;
  height: 12px;
  top: calc(50% - 6px);
}
</style>
